//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
import { connect } from 'react-redux';

//firebase
import { db } from 'assets/firebase';

// @material-ui/style
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import CustomSelect from "components/Select/Select.jsx";

//materialKit components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";

//icons
import Close from "@material-ui/icons/Close";

import StudentEditor from "components/StudentEditor/StudentEditor.jsx";


//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

class StudentList extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      students: [],
      classRooms: [],
      selectedClass: props.classRooms[0].id
    }

    this.studentUpdated = this.studentUpdated.bind(this);
  }

  componentWillMount() {
    
    var classes = [];
    for(var i = 0; i < this.props.classRooms.length; i++) 
      classes.push({key: this.props.classRooms[i].id, label: this.props.classRooms[i].Name});
    
    this.setState({classRooms: classes});

    this.filterStudents(this.state.selectedClass);  
  }

  filterStudents(classID) {

    this.setState({selectedClass: classID, students: []}, function() {

      db.getStudentsByClass(classID).then(snapshot => {
             
        var students = [];
        snapshot.forEach((doc) => {
  
            var student = doc.data();
            student.id = doc.id;
            if(!student.Photos)
              student.Photos = [];
            students.splice(0, 0, student);
  
            this.setState({students: students});
        });
      });
    });
  }

  studentUpdated() {
    this.filterStudents(this.state.selectedClass);
  }

  render() {
    const { classes } = this.props;

    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }

    ReactGA.pageview("admin.allthingseq.com/students");

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success">
              <GridContainer>
                <GridItem xs={12} sm={12} md={10}>
                  <h4 className={classes.cardTitleWhite}>Students</h4>
                </GridItem>
                <GridItem xs={12} sm={12} md={2} style={{textAlign:"right"}}>
                  <Tooltip
                      id="tooltip-top-start"
                      title="Add"
                      placement="left"
                      classes={{ tooltip: classes.tooltip }}
                    >
                      <StudentEditor onChange={this.studentUpdated} 
                        classID={this.state.selectedClass}
                        userType={this.props.userType}
                        student={{
                          FirstName: "",
                          LastName: "",
                          Photos: [],
                          ClassID: this.state.selectedClass,
                          orgId: this.props.org.id
                        }} />
                  </Tooltip>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={false} sm={false} md={8}>
                    &nbsp;
                </GridItem>
                <GridItem xs={12} sm={12} md={4} >
                  <CustomSelect
                      id="classes"
                      labelText="Class"
                      inputProps={{
                          placeholder: "Choose a Class"
                      }}
                      formControlProps={{
                          fullWidth: true
                      }}
                      onChange={(e) => this.filterStudents(e.target.value)}
                      options={this.state.classRooms}
                      value={this.state.selectedClass}
                    />
                </GridItem>
                <GridItem xs={12}>
                  <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                          <TableCell style={{width:"54px", padding:"3px"}}>
                            &nbsp;
                          </TableCell>
                          <TableCell style={{padding:"3px"}}>
                              Name
                          </TableCell>
                          <TableCell style={{padding:"3px"}}>
                              Email
                          </TableCell>
                          <TableCell style={{padding:"3px"}}>
                              User Name
                          </TableCell>
                          <TableCell style={{width:"54px", padding:"3px"}}>
                              &nbsp;
                          </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.students.map(value => (
                        <TableRow key={value.id} className={classes.tableRow}>
                          <TableCell className={classes.tableActions} style={{width:"54px", padding:"3px"}}>
                            <Tooltip
                              id="tooltip-top"
                              title="Edit Student"
                              placement="top"
                              classes={{ tooltip: classes.tooltip }}
                            >
                            <StudentEditor student={value} 
                                classID={this.state.selectedClass} 
                                userType={this.props.userType}
                                onChange={this.studentUpdated} />
                            </Tooltip>
                          </TableCell>
                          <TableCell className={classes.tableCell} style={{padding:"3px"}}>
                            {value.FirstName} {value.LastName}
                          </TableCell>
                          <TableCell className={classes.tableCell} style={{padding:"3px"}}>
                            {value.EmailAddress}
                          </TableCell>
                          <TableCell className={classes.tableCell} style={{padding:"3px"}}>
                            {value.UserName}
                          </TableCell>
                          <TableCell className={classes.tableActions} style={{width:"54px", padding:"3px"}}>
                            <Tooltip
                              id="tooltip-top-start"
                              title="Remove Student"
                              placement="top"
                              classes={{ tooltip: classes.tooltip }}
                            >
                              <IconButton
                                aria-label="Close"
                                className={classes.tableActionButton}
                              >
                                <Close
                                  className={
                                    classes.tableActionButtonIcon + " " + classes.close
                                  }
                                />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = state => {
  return state;
}/*
function mapDispatchToProps(dispatch) {
  return bindActionCreators({onClassSelected: ClassSelected }, dispatch);  
}
*/
StudentList = connect(mapStateToProps)(StudentList);
export default withStyles(styles)(StudentList);



// WEBPACK FOOTER //
// ./src/views/StudentList/StudentList.jsx